type RouteLoader = () => Promise<unknown>

const routeLoaders: Record<string, RouteLoader> = {
  '/dashboard': () => import('@/views/DashboardPage.vue'),
  '/classes': () => import('@/views/ClassPage.vue'),
  '/students': () => import('@/views/StudentPage.vue'),
  '/questions': () => import('@/views/ResourceHubPage.vue'),
  '/smart-engine': () => import('@/views/SmartEnginePage.vue'),
  '/homeworks': () => import('@/views/HomeworkPage.vue'),
  '/corrections': () => import('@/views/GradingPage.vue'),
  '/grading/review': () => import('@/views/GradingWorkspace.vue'),
  '/future-class': () => import('@/views/FutureClassDashboard.vue'),
  '/geometry': () => import('@/views/GeometryWorkspacePage.vue'),
  '/essay-grading': () => import('@/views/EssayGradingPage.vue'),
  '/errors': () => import('@/views/ErrorPage.vue'),
  '/analytics': () => import('@/views/AnalyticsPage.vue'),
  '/risk-warnings': () => import('@/views/RiskWarningPage.vue'),
  '/school': () => import('@/views/SchoolDashboard.vue'),
  '/admin': () => import('@/views/AdminView.vue'),
  '/hardware-devices': () => import('@/views/HardwareDevicesView.vue'),
}

const pendingOrLoaded = new Set<string>()

function allowsPrefetch(): boolean {
  const connection = (navigator as Navigator & {
    connection?: { saveData?: boolean; effectiveType?: string }
  }).connection
  if (connection?.saveData) return false
  return !['slow-2g', '2g'].includes(connection?.effectiveType || '')
}

export function prefetchRoute(rawPath: string): Promise<void> {
  const path = rawPath.split('?')[0]
  const loader = routeLoaders[path]
  if (!loader || !allowsPrefetch() || pendingOrLoaded.has(path)) {
    return Promise.resolve()
  }
  pendingOrLoaded.add(path)
  return loader().then(
    () => undefined,
    () => {
      pendingOrLoaded.delete(path)
    },
  )
}
